import { usePerformanceMark } from './performance-mark.mjs';

function PerformanceMark({
  stage,
  id
}) {
  usePerformanceMark(stage, id);
  return null;
}

export { PerformanceMark };
